<template>
  <canvas id="canvas" width="200" height="200"></canvas>
</template>

<script>
import Chart from "chart.js";
export default {
  name: "ChartView",
  data() {
    return {
      ctx: null,
      chart: null
    };
  },
  props: {
    type: {
      type: String,
      default: null
    },
    labels: Array,
    datasets: Array,
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
    let canvas = document.querySelector("#canvas");
    this.ctx = canvas.getContext("2d");

    this.chart = new Chart(this.ctx, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: this.options
    });
  }
};
</script>

<style scoped>
</style>